module.exports = __webpack_public_path__ + "images/stickers/heart.cc9d955a9ae38ff99b64.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/heart.png
// module id = aRFN
// module chunks = 12